<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Pemberi Rekomendasi"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col md="6" v-for="item in pemberi_rekomendasi" :key="`${item.pertanyaan_id}-pr`">
              <b-form-group
                :label="item.pertanyaan"
                :label-for="item.pertanyaan"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="item.v_model"
                  :rules="item.is_required === 'ya' ? 'required' : ''"
                >
                  <b-form-input
                    v-if="item.tipe === 'input-text'"
                    id="nama"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="`Ketik ${item.v_model}`"
                    v-model="item.jawaban"
                  />
                  <v-select
                    v-else-if="item.tipe === 'select'"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="kapasitasOptions.options"
                    class="w-100"
                    :reduce="val => val.value"
                    :state="errors.length > 0 ? false:null"
                    v-model="item.jawaban"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        title="Penilaian (Assessment)"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col class="mb-2" md="12" v-for="item in penilaian" :key="`${item.pertanyaan_id}-pa`">
              <b-form-group
                :label="item.pertanyaan"
                :label-for="item.pertanyaan"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="item.v_model"
                  :rules="item.is_required === 'ya' ? 'required' : ''"
                >
                <b-form-radio-group
                  :id="`${item.id}`"
                  v-model="item.jawaban"
                  :options="options"
                  :name="item.v_model"
                ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col class="mb-2" md="12" v-for="item in penilaian_rekomendasi" :key="`${item.pertanyaan_id}-p`">
              <b-form-group
                :label="item.pertanyaan"
                :label-for="item.pertanyaan"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="item.v_model"
                  :rules="item.is_required === 'ya' ? 'required' : ''"
                >
                <b-form-radio-group
                  :id="`${item.id}`"
                  v-model="item.jawaban"
                  :options="optionsPR"
                  :name="item.v_model"
                ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Uraian (Description)"
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row>
            <b-col md="12" v-for="item in uraian" :key="`${item.pertanyaan_id}-u`">
              <b-form-group
                :label="item.pertanyaan"
                :label-for="item.pertanyaan"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="item.v_model"
                  :rules="item.is_required === 'ya' ? 'required' : ''"
                >
                <b-form-textarea
                  :id="`${item.id}`"
                  v-model="item.jawaban"
                  :name="item.v_model"
                  :rows="5"
                ></b-form-textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- social link -->
      <tab-content
        title="Kesediaan Dihubungi (Willingness to be contact)"
        :before-change="validationFormSocial"
      >
        <validation-observer
          ref="socialRules"
          tag="form"
        >
          <b-row>
            <b-col class="mb-2" md="12" v-for="item in kesediaan" :key="`${item.pertanyaan_id}-k`">
              <b-form-group
                :label="item.pertanyaan"
                :label-for="item.pertanyaan"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="item.v_model"
                  :rules="item.is_required === 'ya' ? 'required' : ''"
                >
                <b-form-input
                    v-if="item.tipe === 'input-text'"
                    id="nama"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="`Ketik ${item.v_model}`"
                    v-model="item.jawaban"
                  />
                <b-form-radio-group
                  v-else
                  :id="`${item.id}`"
                  v-model="item.jawaban"
                  :options="optionsBA"
                  :name="item.v_model"
                ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadioGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { codeIcon } from './code'
import {
  getPertanyaanPerekomendasi,
  simpanJawabanPerekomendasi
} from '@/connection-api/master'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormRadioGroup,
    BFormTextarea,
  },
  data() {
    return {
      pemberi_rekomendasi: {},
      penilaian: {},
      penilaian_rekomendasi: {},
      kesediaan: {},
      uraian: {},
      rawData: {},
      selectedContry: '',
      selectedLanguage: '',
      name: '',
      emailValue: '',
      PasswordValue: '',
      passwordCon: '',
      first_name: '',
      last_name: '',
      address: '',
      landMark: '',
      pincode: '',
      twitterUrl: '',
      facebookUrl: '',
      googleUrl: '',
      linkedinUrl: '',
      city: '',
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      kapasitasOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Kapasitas' },
          { value: 'pembimbing akademik', label: 'Pembimbing Akademik' },
          { value: 'pembimbing skripsi', label: 'Pembimbing Skripsi' },
          { value: 'pembimbing tesis', label: 'Pembimbing Tesis' },
          { value: 'pembimbing disertasi', label: 'Pembimbing Disertasi' },
          { value: 'atasan', label: 'Atasan' },
          { value: 'lainnya', label: 'Lainnya' },
        ],
      },
      selected: 'first',
        options: [
          { text: 'Dibawah Rata Rata (Below Average)', value: 'dibawah' },
          { text: 'Rata Rata (Average)', value: 'rata rata' },
          { text: 'Baik (Above Avegrage)', value: 'baik' },
          { text: 'Sangat Baik (Superior)', value: 'sangat baik' }
        ],
        optionsPR: [
          { text: 'Saya sangat merekomendasikan Peserta untuk mengikuti program studi  (I highly recommend Participants to enroll the psychology professional study program)', value: 'sangat merekomendasikan' },
          { text: 'Saya merekomendasikan Peserta untuk mengikuti program studi   (I recommend participants to enroll a professional psychology study program)', value: 'merekomendasikan' },
          { text: 'Saya tidak merekomendasikan Peserta untuk mengikuti program studi  (I do not recommend participants to enroll the professional psychology study program)', value: 'tidak merekomendasikan' },
          { text: 'Saya tidak dapat memberikan komentar  (I cant comment)', value: 'tidak berkomentar' }
        ],
        optionsBA: [
          { text: 'Saya bersedia dihubungi (baik melalui email maupun telepon) untuk konfirmasi penilaian Peserta. (I am willing to be contacted (either via email or telephone) for the confirmation of the assessment of the Participant)', value: 'bersedia dikontak' },
          { text: 'Saya tidak bersedia dihubungi. (I dont want to be contacted).', value: 'tidak bersedia dikontak' },
        ],
    }
  },
  mounted() {
    getPertanyaanPerekomendasi(this.$route.params.token)
      .then(response => {
        if (response.data.success == true) {
          this.pemberi_rekomendasi = response.data.data.pemberi_rekomendasi
          this.penilaian = response.data.data.penilaian
          this.penilaian_rekomendasi = response.data.data.penilaian_rekomendasi
          this.uraian = response.data.data.uraian
          this.kesediaan = response.data.data.kesediaan
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('adminUserData')
      localStorage.removeItem('token')
      localStorage.removeItem('tipe')
      localStorage.removeItem('accessToken')

      // Redirect to login page
      this.$router.go(0)
    },
    formSubmitted() {
      const data = {
        token: this.$route.params.token,
        pemberi_rekomendasi: this.pemberi_rekomendasi,
        penilaian: this.penilaian,
        penilaian_rekomendasi: this.penilaian_rekomendasi,
        uraian: this.uraian,
        kesediaan: this.kesediaan,
      }
      simpanJawabanPerekomendasi(data)
      .then(response => {
        if (response.data.success == true) {
            this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Data berhasil disimpan',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          setTimeout(() => {
            this.logout()
          }, 3000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Data gagal disimpan',
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
        }
      })
      .catch(error => console.log(error));
     
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
  },
}
</script>
<style>
.form-group label {
  font-size:1em!important;
}
</style>